import React from 'react';

export default function StarRating({ value, onChange, size = 16 }) {
  const [hover, setHover] = React.useState(0);
  const interactive = !!onChange;

  const starStyle = (index) => {
    const filled = interactive
      ? (hover || value) >= index
      : value >= index;

    return {
      fontSize: size,
      color: filled ? 'var(--color-accent)' : 'rgba(201,169,110,0.3)',
      cursor: interactive ? 'pointer' : 'default',
      opacity: interactive && hover >= index && hover !== value ? 0.7 : 1,
      transition: 'opacity 0.2s, color 0.2s',
    };
  };

  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <span
          key={i}
          style={starStyle(i)}
          onClick={interactive ? () => onChange(i) : undefined}
          onMouseEnter={interactive ? () => setHover(i) : undefined}
          onMouseLeave={interactive ? () => setHover(0) : undefined}
        >
          ★
        </span>
      ))}
    </div>
  );
}
